import "./index.scss";

const TextTitle = ({ title }) => {
  return (
    <h6 className="text-title">{title}</h6>
  );
};

export default TextTitle
